import { render, staticRenderFns } from "./HealthNicheIcon.vue?vue&type=template&id=33ce3c44&scoped=true"
import script from "./HealthNicheIcon.vue?vue&type=script&lang=js"
export * from "./HealthNicheIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ce3c44",
  null
  
)

export default component.exports